import { render, staticRenderFns } from "./AcertoDespesaItem.vue?vue&type=template&id=f923f5de&scoped=true"
import script from "./AcertoDespesaItem.vue?vue&type=script&lang=js"
export * from "./AcertoDespesaItem.vue?vue&type=script&lang=js"
import style0 from "./AcertoDespesaItem.vue?vue&type=style&index=0&id=f923f5de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f923f5de",
  null
  
)

export default component.exports